function record(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getServerErrorCode(error: unknown): string | null {
  if (!record(error) || !record(error.response) || !record(error.response.data))
    return null;
  return typeof error.response.data.code === 'string'
    ? error.response.data.code
    : null;
}

export function getServerErrorStatus(error: unknown): number | null {
  if (!record(error) || !record(error.response)) return null;
  return typeof error.response.status === 'number'
    ? error.response.status
    : null;
}
